var DataInterchangeRunState;
(function (DataInterchangeRunState) {
    DataInterchangeRunState["Eligible"] = "Eligible";
    DataInterchangeRunState["Queued"] = "Queued";
    DataInterchangeRunState["Running"] = "Running";
    DataInterchangeRunState["OneTime"] = "OneTime";
})(DataInterchangeRunState || (DataInterchangeRunState = {}));
export { DataInterchangeRunState };
